(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noura-towel-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initialize(root) {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    const track = root.querySelector('[data-review-track]');
    const navigation = root.querySelector('[data-review-navigation]');
    const count = root.querySelector('[data-review-count]');
    const cards = [...track.children];
    let current = 0;
    let maximum = 0;
    let step = 0;
    function update() {
      if (!cards.length) return;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 10;
      const cardWidth = cards[0].getBoundingClientRect().width;
      step = cardWidth + gap;
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      maximum = Math.ceil(maxScroll / step);
      current = maxScroll > 0 && track.scrollLeft >= maxScroll - 2 ? maximum : Math.min(maximum, Math.round(track.scrollLeft / step));
      navigation.hidden = maximum === 0;
      const left = track.getBoundingClientRect().left;
      const right = left + track.clientWidth;
      const fullyVisible = Math.min(4, Math.floor((track.clientWidth + gap) / step + 0.01));
      const first = Math.max(0, cards.findIndex(card => card.getBoundingClientRect().left >= left - 1)) + 1;
      count.textContent = first + '–' + Math.min(cards.length, first + fullyVisible - 1) + ' / ' + cards.length;
      cards.forEach(card => {
        const box = card.getBoundingClientRect();
        const visible = box.right > left + 1 && box.left < right - 1;
        card.inert = !visible;
        card.setAttribute('aria-hidden', String(!visible));
      });
    }
    root.querySelectorAll('[data-review-direction]').forEach(button => {
      button.addEventListener('click', () => {
        const target = (current + Number(button.dataset.reviewDirection) + maximum + 1) % (maximum + 1);
        track.scrollTo({left: Math.min(track.scrollWidth - track.clientWidth, target * step), behavior: matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth'});
      });
    });
    root.querySelectorAll('[data-review-more]').forEach(button => {
      button.addEventListener('click', () => {
        const card = button.closest('.noura-towel-reviews__card');
        const expanded = card.dataset.expanded !== 'true';
        card.dataset.expanded = String(expanded);
        button.setAttribute('aria-expanded', String(expanded));
        button.textContent = expanded ? button.dataset.less : button.dataset.more;
      });
    });
    track.addEventListener('scroll', update, {passive: true});
    new ResizeObserver(update).observe(track);
    update();
  }
  document.querySelectorAll('[data-noura-towel-reviews]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-noura-towel-reviews]').forEach(initialize));
})();

  } catch(e) { console.error(e); }
})();
})();
